import { Injectable } from '@angular/core';
import { BaseService } from './base/base.service';
import { environment } from 'src/environments/environment'
import { HttpResponse } from '@angular/common/http';

import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Deserializer, Serializer } from 'json-api-format';

import { AppSetting } from 'src/modules/models/settings/casual-portal/app-setting';
import { BaseParam } from '../models/base-param';
import { Item } from '../models/item/item'
import { QuestionSummary } from 'src/modules/models/booking/question-summary';
import { Question } from '../models/item/question'
import { ItemSearchParams } from '../models/item/item-search-params'
import {ParameterMapper} from './base/parameter-mapper';
import {ContactFilters} from '../models/filters/contact-filters';

@Injectable({
    providedIn: 'root'
})

export class ItemService {

    constructor(private _baseService: BaseService) {

    }
    private getPortalConcessions(): any[]
    {
        let portalConcessions = [];
        if (environment.AppSetting) {
            var appSett = environment.AppSetting as AppSetting;
            if (appSett.BookingConfig && appSett.BookingConfig.PriceConcessions) {
                appSett.BookingConfig.PriceConcessions.forEach(pc => { portalConcessions.push(pc.Id) });
            }
        }
        return portalConcessions;
    }
    itemSearch(baseParam: ItemSearchParams): Observable<Item[]> {
        return this._baseService.Internal_WebAPI_GET("api/assets/invoke?id=101&" + baseParam.geturlforsearch()).pipe(
            map((response: any) => {

                 var JsonData = JSON.parse(response.body["data"]);
                var json = new Deserializer().deserialize(JsonData);
                //console.log("Deserialized web api output item");
                //console.log(json);
               // console.log("Convert to object");
                var lst: Item[] = [];
                var portalConcessions = this.getPortalConcessions();

                json.forEach((c, i) => {
                    var item = (c as Item);
                    let salesChannel = c.itemSalesChannels.filter(isc => isc.salesChannel && isc.salesChannel.id=="5" && isc.allowImmediateConfirmedBookings == 1);
                    item.allowImmediateConfirmedBookings =  (salesChannel.length > 0)? 1: 0;
                    item.question = c.itemQuestion;
                    if (c.itemQuestion) {
                      var appSetting = environment.AppSetting as AppSetting;
                      let statusFilterRaw = appSetting?.BookingConfig?.BookingStatusForQuestions ?? "";
                      let statusList = [];
                      let approveStatusList = [];

                      statusList = statusFilterRaw != null && statusFilterRaw != ""
                        ? statusFilterRaw?.split(',').map(s => s.trim())
                        : [String(environment.BookingStatus)];

                      let approveStatusRaw = appSetting?.BookingConfig?.BookingStatusForImmediateBookingQuestions ?? "";
                      approveStatusList = approveStatusRaw != null && approveStatusRaw != ""
                        ? approveStatusRaw.split(',').map(s => s.trim())
                        : [String(environment.BookingApproveStatus)];

                      item.question = c.itemQuestion.filter(iq =>  statusList?.includes(iq?.bookingStatusId?.toString()) || (item.allowImmediateConfirmedBookings && approveStatusList?.includes(iq?.bookingStatusId?.toString())));
                      if(item?.question && item?.question?.length > 0){
                        item.question.sort((a, b) => (a?.questionNo ?? 0) - (b?.questionNo ?? 0));
                      }
                    }
                    if (c.itemPriceGroups)
                        item.itemPriceGroups = c.itemPriceGroups.filter(ipg => portalConcessions.indexOf(ipg.concessionId.toString()) >= 0);
                    else
                        item.itemPriceGroups = [];
                    lst.push(item);
                });
                return lst
            })
        );
    }

    itemSelect(itemId: string){
        let url = `api/assets/invoke?id=121&`;
            url += `itemId=${itemId}`;
        return this._baseService.Internal_WebAPI_GET(url).pipe(map((response: any) => {
            var JsonData = JSON.parse(response.body['data']);
            var json = new Deserializer().deserialize(JsonData);
            return json;
        }))
    }
    GetUpsells(SalesCategoryIds: string, SearchKey: string, FromDate: string, ToDate: string, PageNumber: number, PageSize: number, selectedItemType: number,itemName:string, packageId? :string, LinkingSpaceItemId? : string , venueId? : string ): Observable<any> {

      return this._baseService.InternalWebAPIGET("api/assets/GetUpsells?SalesCategoryIds=" + SalesCategoryIds
          + "&SearchKey=" + SearchKey
          + "&FromDate=" + FromDate
          + "&ToDate=" + ToDate
          + "&PageNumber=" + PageNumber
          + "&PageSize=" + PageSize
          + "&ItemType=" + selectedItemType.toString()
          +"&itemName="+itemName
          +"&packageId="+packageId
          +"&LinkingSpaceItemId="+LinkingSpaceItemId
          +"&venueId="+ venueId
        ).pipe(
            map((response: any) => {
                var json = response.Data;
                var portalConcessions = this.getPortalConcessions();
                if (json)
                {
                  json.forEach(itm => {
                        if (itm.ItemQuestion) {
                          var appSetting = environment.AppSetting as AppSetting;
                          let statusFilterRaw = appSetting?.BookingConfig?.BookingStatusForQuestions ?? "";
                          let statusList = [];

                          statusList = statusFilterRaw != null && statusFilterRaw != ""
                            ? statusFilterRaw?.split(',').map(s => s.trim())
                            : [String(environment.BookingStatus)];

                          itm.question = itm.ItemQuestion.filter(iq => statusList?.includes(iq?.BookingStatusId?.toString()));

                          if(itm?.question && itm?.question?.length > 0){
                            itm.question.sort((a, b) => (a?.questionNo ?? 0) - (b?.questionNo ?? 0));
                          }
                        }
                        if (itm.ItemPriceGroups)
                            itm.ItemPriceGroups = itm.ItemPriceGroups.filter(ipg => portalConcessions.indexOf(ipg.ConcessionId.toString()) >= 0);
                        else
                            itm.ItemPriceGroups = [];
                    });
                }
                return { Data: json, Meta: { TotalResults: response.Meta.TotalResults } };
            })
        );
    }

    GetItemCategories(): Observable<any> {
        return this._baseService.InternalWebAPIGET("api/packages/item-categories").pipe(
            map((response: any) => {
                return response["Data"];
            })
        );
    }

    GetItemPrices(data:any , hideLoader : boolean = false): Observable<any> {
      let filters = {
        disableSpinner: "1"
      };
      let params = "";
      if(hideLoader){
        params = ParameterMapper.mapFilters(filters);
      }
        return this._baseService.InternalWebAPIPOST("api/assets/calculated-prices?" + params ,data).pipe(
            map((response: any) => {
                return response["data"];
            })
        );
    }

    CalculateItemPrice(itemId: string, priceConsessionId: string, qty: number, startTime: string, endTime: string) {

        //return this._baseService.WebAPIGet("api/v4.1/products/items/" + itemId + "/calculate-prices?include=calculatedItempricegroups&Quantity=" + qty + "&PriceConcessionId=" + priceConsessionId + "&StartTime=" + startTime + "&EndTime=" + endTime).pipe(
        return this._baseService.InternalWebAPIGET("api/product/invoke?id=115&" + "&itemSearchFilter.ItemId=" + itemId + "&itemSearchFilter.PriceConcessionId=" + priceConsessionId + "&itemSearchFilter.qty=" + qty + "&itemSearchFilter.FromDate=" + startTime + "&itemSearchFilter.ToDate=" + endTime + "&include=" + "calculatedItempricegroups").pipe(
            map((response) => {
                var JsonData = JSON.parse(response["data"]);
                var json = new Deserializer().deserialize(JsonData);

                console.log("Deserialized web api output CalculateItemPrice");
                console.log(json);
                console.log("Convert to object");
                // this.testFunction();
                return json;
            })
        );
    }

    PostQuestions(_Question: Question[]) {
        console.log("PostQuestion");
        var json = new Serializer().serialize(_Question);
        console.log(json);
        var obj = new Deserializer().deserialize(json);
        let result = this._baseService.Internal_WebAPI_POST("api/booking/questions", obj);

        return result;
    }

    PostQuestionAndAnswer(questionSummaries:QuestionSummary[], bookingID: string) {
        return this._baseService.Internal_WebAPI_POST("api/booking/answer-post/" + bookingID, questionSummaries).subscribe(
            (response : HttpResponse<any>) => {
                return response.body["Data"];
            }
        );
    }
}
